import { render, staticRenderFns } from "./StsTrailer.vue?vue&type=template&id=48fdc56a&"
import script from "./StsTrailer.vue?vue&type=script&lang=js&"
export * from "./StsTrailer.vue?vue&type=script&lang=js&"
import style0 from "./StsTrailer.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports